import { dashboardApiURL } from "API/urls/dashboard.api";
import { axiosInstance } from "configs/axios";

export const outputDoneTaskStatusApi = async (formData) => {
  try {
    const response = await axiosInstance.post(dashboardApiURL.doneTaskOutput, {
      ...formData,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
